export default __webpack_public_path__ + "static/p4engenharia-bcc2c61b3dd3c213309bd18e12d73292.png";